// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1734":"557802e360e91352","7347":"ca32d1cb6bd67cc3","8536":"26c6ee74bb319cfb"}[chunkId] + ".css";
};